
import './cookie-consent.css';
import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';

interface CookieConsentProps {
    onAccept?: () => void;
    onDecline?: () => void;
}

export const CookieConsent: React.FC<CookieConsentProps> = ({ onAccept, onDecline }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = Cookies.get('cookieConsent');
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        Cookies.set('cookieConsent', 'true', { expires: 1 }); 
        setIsVisible(false);
        onAccept?.();
    };

    const handleDecline = () => {
        Cookies.set('cookieConsent', 'false', { expires: 365 });
        setIsVisible(false);
        onDecline?.();
    };

    if (!isVisible) return null;

    return (
        <div className="cookie-consent">
            <p>
                Мы используем cookie для улучшения работы сайта.
            </p>
            <div className="cookie-buttons">
                <button onClick={handleAccept} className="btn-accept">
                    Принять
                </button>
                <button onClick={handleDecline} className="btn-decline">
                    Отклонить
                </button>
            </div>
        </div>
    );
};
